/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import {
  getConfig,
  IThemeConfig,
  PageDataContainer,
  PageLink,
  useTheme,
} from '../../../_start/layout/core';
import { CustomerManagementPage } from './CustomerManagementPage';
import { customerManagementSubmenu } from './CustomerManagementPageData';

const customerManagementBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isActive: false,
  },
  {
    title: 'Customer Management',
    path: '/customer-management',
    isActive: false,
  },
];

const defaultPageConfig = getConfig();
const customerManagementPageConfig: Partial<IThemeConfig> = {
  sidebar: {
    ...defaultPageConfig.sidebar,
    display: false,
    content: 'user',
    bgColor: 'bg-info',
  },
};

export const CustomerManagementWrapper = () => {
  const { setTheme } = useTheme();

  // Refresh UI after config updates
  useEffect(() => {
    setTheme(customerManagementPageConfig);
    return () => {
      setTheme(defaultPageConfig);
    };
  }, []);

  return (
    <>
      <PageDataContainer
        breadcrumbs={customerManagementBreadCrumbs}
        submenu={customerManagementSubmenu}
      />
      <CustomerManagementPage />
    </>
  );
};
